module.exports = __webpack_public_path__ + "static/media/loadingSpinner.d2cd0af6.svg";